// SubscriptionModals.jsx
import React from 'react';
import PropTypes from 'prop-types';

import ModalView from '../container/ModalView.js';

import UniversalContainer from '../component/UniversalContainer.jsx';

export const SubscriptionModals = ({ shopId }) => {
  return (
    <>
      <ModalView
        id="SubscribeAndUnlockModal"
        render={() => <UniversalContainer filename="SubscribeAndUnlockModal" />}
      />
      <ModalView id={`${shopId}.PaymentSourceSelector`}>
        <UniversalContainer filename="PaymentSourceSelector" shopId={shopId} />
      </ModalView>
      <ModalView id={`${shopId}.SecurionpayCardFormModal`}>
        <UniversalContainer
          filename="SecurionpayCardFormModal"
          shopId={shopId}
        />
      </ModalView>
      <ModalView id={`${shopId}.TappayCardFormModal`}>
        <UniversalContainer filename="TappayCardFormModal" shopId={shopId} />
      </ModalView>
    </>
  );
};

SubscriptionModals.propTypes = {
  shopId: PropTypes.string,
};

SubscriptionModals.defaultProps = {
  shopId: '',
};

export default SubscriptionModals;
